"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contratosOrionNormalizer = void 0;
const contratosOrionNormalizer = (data) => {
    const dataContratosNormalizado = [];
    if (data && Array.isArray(data) && data.length > 0) {
        data.forEach((modulo) => {
            if (modulo && modulo.fields) {
                const categoriasContratos = [];
                const { mainTitle, categoriasContrato } = modulo.fields;
                if (categoriasContrato && Array.isArray(categoriasContrato) && categoriasContrato.length > 0) {
                    categoriasContrato.forEach((categoria) => {
                        if (categoria && categoria.fields) {
                            let subCategoriasContratosObject = {};
                            const { titleSubtegory, subCategoriasContratos } = categoria.fields;
                            if (subCategoriasContratos && subCategoriasContratos.fields) {
                                const listadoContratosArray = [];
                                const { title, ListadoContratos } = subCategoriasContratos.fields;
                                if (ListadoContratos && Array.isArray(ListadoContratos) && ListadoContratos.length > 0) {
                                    ListadoContratos.forEach((contrato) => {
                                        if (contrato && contrato.fields) {
                                            const { icono, titlePDF, urlDescarga } = contrato.fields;
                                            let urlComplex = "";
                                            if (urlDescarga.indexOf('http') === -1 && urlDescarga.indexOf('//') === -1) {
                                                if (process.env.NEXT_PUBLIC_ENV_NAME === "prod") {
                                                    urlComplex = "https://prod.adb.col.movistar.es" + urlDescarga;
                                                }
                                                else {
                                                    urlComplex = "https://author.prod.aem.col.movistar.es" + urlDescarga;
                                                }
                                            }
                                            else {
                                                urlComplex = urlDescarga;
                                            }
                                            listadoContratosArray.push({
                                                icon: icono || '',
                                                title: titlePDF || '',
                                                url: urlComplex || '',
                                            });
                                        }
                                    });
                                }
                                subCategoriasContratosObject = {
                                    title: title || '',
                                    listadoContratos: listadoContratosArray || [],
                                };
                            }
                            categoriasContratos.push({
                                title: titleSubtegory || '',
                                subCategoriasContratos: subCategoriasContratosObject || {},
                            });
                        }
                    });
                }
                if (categoriasContratos && categoriasContratos.length > 0) {
                    dataContratosNormalizado.push({
                        title: mainTitle || '',
                        categoriasContratos: categoriasContratos || [],
                    });
                }
            }
        });
    }
    return dataContratosNormalizado;
};
exports.contratosOrionNormalizer = contratosOrionNormalizer;
exports.default = exports.contratosOrionNormalizer;
//# sourceMappingURL=index.js.map